import './style.scss'
import Label from 'components/Label';
// import { data } from './mockData'
import AboutLayout from './AboutLayout';
import { useRef } from 'react';
import { useAnimation } from 'hooks/useAnimation';


const AboutUsSection = ({ aboutUs, isLoading, }) => {
    const container = useRef();

    const {
        // id,
        tag,
        title,
        description,
        cards,
    } = aboutUs

    useAnimation({
        items: ['.aboutus-section h2', '.aboutus-section-item', '.aboutus-section-card'],
        container,
        dependencies: [isLoading],
    })


    return (
        <section ref={container} className="inner-container aboutus-section">
            <Label text={tag} />
            <h2>{title}</h2>
            <AboutLayout description={description} cards={cards} />
        </section>
    );
}

export default AboutUsSection;